import { useQuery, UseQueryOptions, UseQueryResult } from "react-query";
import { endpoints } from "../api/constants/endpoints";
import { ProviderInfo } from "../api/interfaces/Provider";
import fetcher from "../utils/fetchWrapper";

const getProvider = async () => {
  const response = await fetcher(
    `${endpoints.getProvider}?loading=Contacts.Location&filter=Contacts.status neq INACTIVE`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error();
  }
  return await response.json();
};

export const useGetProvider = (
  options?: UseQueryOptions<ProviderInfo, Error, ProviderInfo, Array<string>>
): UseQueryResult<ProviderInfo, Error> =>
  useQuery(["provider"], getProvider, options);
